/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useRef, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import ImageLoad from '../ImageLoad';
import secureLocalStorage from 'react-secure-storage';
import Slider from "react-slick";
import { LuPlus, LuMinus, LuShoppingBag, LuChevronRight } from "react-icons/lu";
import { MdOutlineMedicalServices } from "react-icons/md";
import { IoClose } from "react-icons/io5";

const Shop = () => {

    const { t } = useTranslation();

    const { ApiBaseUrl, ImgBaseUrl, medicineId, setIsLoginShow } = useContext(MyContext);

    const [categoryList, setCategoryList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [apiLoading, setApiLoading] = useState(false);
    const [detailsShow, setDetailsShow] = useState(false);
    const [detailsData, setDetailsData] = useState([]);
    const [isShow, setisShow] = useState("");
    const [details, setDetails] = useState([]);
    const [productId, setProductId] = useState();
    const [cartData, setCartData] = useState([]);

    const navigate = useNavigate();
    const LoadingRef = useRef(false);

    const site_currency = secureLocalStorage.getItem("currency");
    const currency = site_currency ? site_currency : "$";

    const settings2 = {
        arrows: false,
        dots: true,
        infinite: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        const customer_id = secureLocalStorage.getItem("Userid");
        axios.post(`${ApiBaseUrl}/customer/customer_category_list`, { customer_id })
            .then((res) => {
                if (res.data.ResponseCode === 200) {
                    setLoading(false);
                    setCategoryList(res.data.category_list);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, [ApiBaseUrl]);

    useEffect(() => {
        if (!medicineId) return;
        const Userid = secureLocalStorage.getItem("Userid") || "0";
        setApiLoading(true);
        setDetailsShow(true);
        axios.post(`${ApiBaseUrl}/customer/product_detail`, { uid: Userid, doctor_id: medicineId?.store_id, prod_id: medicineId?.id })
            .then((res) => {
                setDetailsData([res.data.product]);
                setApiLoading(false);
            })
            .catch((error) => {
                console.error(error);
            });
    }, [medicineId, ApiBaseUrl]);

    const HandleNavigate = (id) => {
        navigate("/shop-list");
        sessionStorage.setItem("Catid", id);
    }

    useEffect(() => {
        loading
            ? document.body.style.overflow = "hidden"
            : document.body.style.overflow = "auto";
    }, [loading]);

    const HandleShowPriceDetails = (e, items, index) => {
        e.stopPropagation();
        setDetailsShow(false);
        setProductId(items.id);
        setisShow({ name: items.product_name, img: index === 1 ? items.product_image[0] : items.product_image });
        setDetails(items.price_detail);
        const Data = { id: items.id, price_detail: items.price_detail };
        setCartData([...cartData, Data]);
    };

    return (
        <div className='w-full width-container pb-[50px] content-wrapper px-4 md:px-6 max-w-7xl mx-auto'>
            {loading ? (
                <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white z-[9999]" />
            ) : (
                <div className="flex flex-col">

                    {/* Shop by Categories Grid */}
                    <div className="ourservices mt-4">
                        <div className="mb-6">
                            <h2 className="text-2xl font-bold text-slate-800 tracking-tight">{t("Shop by Categories")}</h2>
                            <p className="text-sm text-slate-500 mt-1">{t("Explore our wide range of categories curated for your healthcare needs")}</p>
                        </div>
                        
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 mt-[20px]">
                            {categoryList.map((item, index) => {
                                return (
                                    <div 
                                        onClick={() => HandleNavigate(item.id)} 
                                        key={index} 
                                        className="group bg-white rounded-2xl border border-slate-150 hover:border-indigo-500/30 cursor-pointer shadow-sm hover:shadow-md hover:-translate-y-1.5 transition-all duration-350 p-5 flex flex-col justify-center items-center text-center relative overflow-hidden"
                                    >
                                        <div className="absolute inset-0 bg-gradient-to-b from-indigo-50/0 to-indigo-50/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                        <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-slate-50 group-hover:bg-indigo-50/80 flex items-center justify-center p-3 mb-4 transition-all duration-300 relative z-10">
                                            <ImageLoad 
                                                src={ImgBaseUrl + item.image} 
                                                CustomeStyle={"w-full h-full object-contain transition-transform duration-300 group-hover:scale-110"} 
                                                alt={item.name} 
                                            />
                                        </div>
                                        <h3 className="font-semibold text-slate-800 text-sm md:text-base group-hover:text-indigo-600 transition-colors duration-200 line-clamp-1 w-full relative z-10">
                                            {item.name}
                                        </h3>
                                        <span className="text-[11px] font-medium text-indigo-600 bg-indigo-50 px-2 py-0.5 rounded-full mt-2.5 opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-1 group-hover:translate-y-0 relative z-10">
                                            {t("Explore")} <LuChevronRight className="inline-block w-3 h-3 -mt-0.5" />
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            )}

            {/* Premium Product Details Modal */}
            {detailsShow && (
                <div 
                    onClick={() => setDetailsShow(false)} 
                    className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
                >
                    <div 
                        onClick={(e) => e.stopPropagation()} 
                        className="bg-white rounded-[24px] shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto scroll-container p-5 md:p-8 relative"
                    >
                        {/* Close Button */}
                        <button 
                            onClick={() => setDetailsShow(false)}
                            className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-all duration-200 z-20"
                            aria-label="Close modal"
                        >
                            <IoClose className="w-6 h-6" />
                        </button>

                        {apiLoading ? (
                            <div className="w-full h-[400px] flex flex-col items-center justify-center gap-3">
                                <div className="loader2"></div>
                                <span className="text-slate-500 font-medium text-sm">{t("Loading details...")}</span>
                            </div>
                        ) : (
                            <div className="mt-2">
                                {detailsData.map((item, index) => {
                                    const singleLineText = item?.description ? item.description.replace(/\r\n|\r|\n/g, '<br />') : '';
                                    const TotalCart = item.price_detail ? item.price_detail.reduce((acc, curr) => acc + curr.cart_qty, 0) : 0;
                                    return (
                                        <div key={index} className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                            {/* Left Column: Image Slider */}
                                            <div className="flex flex-col justify-center">
                                                <div className="slider-container relative rounded-2xl overflow-hidden border border-slate-100 p-2 bg-slate-50">
                                                    <Slider {...settings2}>
                                                        {item.product_image && item.product_image.map((img, imgIdx) => {
                                                            return (
                                                                <div key={imgIdx} className="outline-none py-4">
                                                                    <ImageLoad 
                                                                        src={ImgBaseUrl + img} 
                                                                        CustomeStyle={"h-[240px] md:h-[280px] object-contain w-full rounded-xl mix-blend-multiply"} 
                                                                        alt={item.product_name} 
                                                                    />
                                                                </div>
                                                            );
                                                        })}
                                                    </Slider>
                                                </div>
                                            </div>
                                            
                                            {/* Right Column: Details Content */}
                                            <div className="flex flex-col justify-between">
                                                <div>
                                                    {/* Prescription Required Warning */}
                                                    {item.prescription_require === "Required" && (
                                                        <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-rose-50 text-rose-600 border border-rose-100 mb-3">
                                                            <MdOutlineMedicalServices className="w-4 h-4 text-rose-500" />
                                                            <span>{t("Prescription Required")}</span>
                                                        </div>
                                                    )}
                                                    
                                                    <h1 className="font-bold text-slate-800 text-xl md:text-2xl leading-snug tracking-tight">
                                                        {item.product_name}
                                                    </h1>
                                                    
                                                    {/* Price Panel */}
                                                    {item.price_detail && item.price_detail[0] && (
                                                        <div className="flex items-baseline gap-2.5 mt-4 pb-4 border-b border-slate-100">
                                                            <span className="font-extrabold text-slate-900 text-2xl">
                                                                {currency}{item.price_detail[0].price}
                                                            </span>
                                                            {item.price_detail[0].base_price && item.price_detail[0].base_price !== item.price_detail[0].price && (
                                                                <span className="line-through text-slate-400 font-medium">
                                                                    {currency}{item.price_detail[0].base_price}
                                                                </span>
                                                            )}
                                                            {item.price_detail[0].discount !== 0 && (
                                                                <span className="bg-orange-50 text-orange-600 border border-orange-100 px-2.5 py-0.5 rounded-full text-xs font-semibold">
                                                                    {item.price_detail[0].discount}% OFF
                                                                </span>
                                                            )}
                                                        </div>
                                                    )}
                                                    
                                                    {/* Description */}
                                                    <div className="mt-5">
                                                        <h3 className="font-semibold text-slate-700 text-sm tracking-wider uppercase mb-2">{t("Product Overview")}</h3>
                                                        <div 
                                                            className="text-slate-500 text-sm leading-relaxed max-h-[150px] overflow-y-auto pr-2 scroll-container" 
                                                            dangerouslySetInnerHTML={{ __html: singleLineText }} 
                                                        />
                                                    </div>
                                                </div>
                                                
                                                {/* Action Bar */}
                                                <div className="mt-6 pt-4 border-t border-slate-100 flex items-center justify-between gap-4">
                                                    <div className="flex flex-col">
                                                        <span className="text-slate-400 text-xs font-semibold uppercase tracking-wider">{t("Unit Option")}</span>
                                                        <span className="text-slate-700 font-bold text-base mt-0.5">
                                                            {item.price_detail ? item.price_detail.length : 0} {item.price_detail && item.price_detail.length === 1 ? t("Option") : t("Options")}
                                                        </span>
                                                    </div>
                                                    
                                                    <button 
                                                        onClick={(e) => HandleShowPriceDetails(e, item, 1)} 
                                                        className={`flex items-center justify-center font-semibold px-6 py-3 rounded-full shadow-sm hover:shadow active:scale-95 transition-all duration-200 text-sm tracking-wide ${TotalCart ? 'bg-indigo-50 text-indigo-700 border border-indigo-200' : 'bg-indigo-600 text-white hover:bg-indigo-700'}`}
                                                    >
                                                        {TotalCart ? (
                                                            <span className="flex items-center gap-2">
                                                                <LuShoppingBag className="w-4 h-4" />
                                                                {TotalCart} {t("In Cart")}
                                                            </span>
                                                        ) : (
                                                            t("Select Options")
                                                        )}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* Premium Variant Selection Modal */}
            {isShow && (
                <div 
                    onClick={() => setisShow("")} 
                    className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4"
                >
                    <div 
                        onClick={(e) => e.stopPropagation()} 
                        className="bg-white rounded-[24px] shadow-2xl max-w-lg w-full max-h-[85vh] flex flex-col p-6 relative"
                    >
                        {/* Close Button */}
                        <button 
                            onClick={() => setisShow("")}
                            className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-all duration-200 z-20"
                            aria-label="Close modal"
                        >
                            <IoClose className="w-5 h-5" />
                        </button>
                        
                        <div className="mb-4 pr-8">
                            <span className="text-xs font-semibold uppercase tracking-wider text-indigo-600 bg-indigo-50 px-2.5 py-1 rounded-md inline-block mb-1">{t("Select Variant")}</span>
                            <h1 className="font-bold text-slate-800 text-lg md:text-xl line-clamp-1">{isShow.name}</h1>
                        </div>

                        <div className="flex-1 overflow-y-auto scroll-container pr-1 py-1 max-h-[420px]">
                            {details.map((item, index) => {
                                return (
                                    <DetailsSheet 
                                        key={index} 
                                        item={item} 
                                        isShow={isShow} 
                                        ImgBaseUrl={ImgBaseUrl} 
                                        currency={currency} 
                                        LoadingRef={LoadingRef} 
                                        setisShow={setisShow} 
                                        setIsLoginShow={setIsLoginShow} 
                                        Docid={medicineId?.store_id} 
                                        productId={productId} 
                                        details={details} 
                                        ApiBaseUrl={ApiBaseUrl} 
                                        setDetails={setDetails} 
                                    />
                                );
                            })}
                        </div>
                        
                        <div className="mt-6 pt-4 border-t border-slate-100">
                            <button 
                                onClick={() => setisShow("")} 
                                className="w-full bg-slate-900 hover:bg-slate-800 text-white font-semibold text-base rounded-full py-3.5 shadow-md hover:shadow-lg active:scale-[0.99] transition-all duration-200"
                            >
                                {t("Done")}
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    )
}

export default Shop
/* jshint ignore:end */

const DetailsSheet = ({ item, isShow, ImgBaseUrl, currency, LoadingRef, setisShow, setIsLoginShow, Docid, productId, details, ApiBaseUrl, setDetails }) => {

    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);

    const handleAddToCart = (item) => {

        const Userid = secureLocalStorage.getItem("Userid");

        if (LoadingRef.current) {
            return;
        }

        if (!Userid) {
            setisShow("");
            setIsLoginShow(true);
            return;
        }

        setLoading(true);
        LoadingRef.current = true;

        const payload = {
            uid: Userid,
            doctor_id: Docid,
            prod_id: productId,
            pro_price: item.price,
            pro_ptype: item.title,
            pro_qty: item.cart_qty,
            pro_qty_type: 1,
            mode: 1,
        };

        const updatedDetails = details.map(detail =>
            detail.title === item.title
                ? { ...detail, cart_qty: detail.cart_qty + 1 }
                : detail
        );

        axios.post(`${ApiBaseUrl}/customer/cart_detail`, payload)
            .then((response) => {
                setLoading(false);
                LoadingRef.current = false;
                setDetails(updatedDetails);
            })
            .catch((error) => {
                console.error('Failed to add item to cart:', error);
                setLoading(false);
                LoadingRef.current = false;
            });
    };

    const handleRemoveToCart = (item) => {
        const Userid = secureLocalStorage.getItem("Userid");

        if (LoadingRef.current) {
            return;
        }

        if (Userid) {

            setLoading(true);
            LoadingRef.current = true;

            const Data = {
                uid: Userid,
                doctor_id: Docid,
                prod_id: productId,
                pro_price: item.price,
                pro_ptype: item.title,
                pro_qty: item.cart_qty,
                pro_qty_type: 2,
                mode: 1
            };

            const updatedDetails = details.map(detail =>
                detail.title === item.title
                    ? { ...detail, cart_qty: detail.cart_qty - 1 }
                    : detail
            );

            axios.post(`${ApiBaseUrl}/customer/cart_detail`, Data)
                .then((res) => {
                    setLoading(false);
                    LoadingRef.current = false;
                    setDetails(updatedDetails);
                })
                .catch((error) => {
                    console.error(error);
                    setLoading(false);
                    LoadingRef.current = false;
                });
        }
    };

    return (
        <div className="bg-slate-50 hover:bg-slate-100/60 border border-slate-100/80 rounded-2xl p-4 transition-all duration-200 shadow-sm flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-3">
            <div className="flex items-center gap-4">
                <div className="relative group overflow-hidden rounded-xl border border-slate-200/60 bg-white p-1">
                    <ImageLoad src={ImgBaseUrl + isShow.img} CustomeStyle={"w-[72px] h-[72px] object-contain rounded-lg transition-transform duration-300 group-hover:scale-105"} alt={"img"} />
                </div>
                <div className="leading-snug">
                    <h2 className='font-semibold text-slate-800 text-[16px]'>{isShow.name}</h2>
                    <span className='text-xs font-medium px-2 py-0.5 bg-slate-200/60 text-slate-600 rounded-md inline-block mt-1'>{item.title}</span>
                    <div className="flex items-baseline gap-2 mt-2">
                        <span className='font-bold text-slate-900 text-lg'>{currency}{item.price}</span>
                        {item.base_price && item.base_price !== item.price && (
                            <span className='line-through text-slate-400 text-sm'>{currency}{item.base_price}</span>
                        )}
                        {item.discount !== 0 && (
                            <span className='bg-orange-50 text-orange-600 border border-orange-100 px-2 py-0.5 rounded-full text-xs font-semibold ml-1.5'>
                                {item.discount}% OFF
                            </span>
                        )}
                    </div>
                </div>
            </div>
            <div className="flex justify-end sm:justify-start">
                <div className={`flex items-center justify-center min-w-[100px] h-10 border transition-all duration-200 rounded-full font-medium ${item.cart_qty ? 'bg-indigo-50 border-indigo-200 text-indigo-700' : 'bg-indigo-600 border-indigo-600 hover:bg-indigo-700 text-white shadow-sm hover:shadow'}`}>
                    {loading ? (
                        <div className="px-5 py-2">
                            <div className="loader2 mx-auto"></div>
                        </div>
                    ) : item.cart_qty ? (
                        <div className="flex items-center justify-between w-full px-2 gap-3">
                            <button 
                                onClick={() => handleRemoveToCart(item)}
                                className="w-7 h-7 flex items-center justify-center rounded-full hover:bg-indigo-200/50 text-indigo-700 active:scale-90 transition-all duration-150"
                                aria-label="Decrease quantity"
                            >
                                <LuMinus className="w-4 h-4" />
                            </button>
                            <span className="font-semibold text-base select-none">{item.cart_qty}</span>
                            <button 
                                onClick={() => handleAddToCart(item)}
                                className="w-7 h-7 flex items-center justify-center rounded-full hover:bg-indigo-200/50 text-indigo-700 active:scale-90 transition-all duration-150"
                                aria-label="Increase quantity"
                            >
                                <LuPlus className="w-4 h-4" />
                            </button>
                        </div>
                    ) : (
                        <button 
                            onClick={() => handleAddToCart(item)} 
                            className="w-full h-full text-center text-sm font-semibold tracking-wide uppercase px-5"
                        >
                            {t("Add")}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}